import styled from "styled-components";

export const TDList = styled.td`
    width: 200px !important;
`;